module.exports = __webpack_public_path__ + "static/media/notifications.88001fb8.svg";